import type { GraphQLFormattedError } from "graphql"
import type { NetworkError } from "@apollo/client/errors"

/**
 * GraphQL-Fehler, die der Server bewusst als Antwort auf eine fachlich ungültige
 * Anfrage erzeugt (graphql-java-Klassifikation `ValidationError`: Schema-Validierung
 * wie FieldUndefined bei Deploy-Skew, und unsere `errorneous(...)`-Businessfehler wie
 * "opens must be before closes"). Der Nutzer sieht sie als Toast; für Sentry sind sie
 * kein Signal. `VERSION_CONFLICT` ist ebenfalls erwartet: useForm loest ihn selbst durch
 * Neuladen + Zusammenfuehren auf.
 */
export function isExpectedGraphQlError(error: GraphQLFormattedError): boolean {
  const classification = error.extensions?.classification
  return classification === "ValidationError" || classification === "VERSION_CONFLICT"
}

/**
 * Netzwerkfehler ohne Signalwert für das CMS: abgelaufene Session (401 — die
 * Keycloak-Re-Authentifizierung übernimmt), Gateway-Fehler während eines Deploys
 * (502–504), abgebrochene Requests (Timeout/Navigation), der WebSocket-Abriss
 * beim Neustart ("Socket closed") und Browser-Fetch-Fehler (offline, Blips).
 */
export function isExpectedNetworkError(error: NetworkError): boolean {
  if (!(error instanceof Error)) return false
  if (error.name === "AbortError") return true
  if (error.message === "Socket closed") return true
  if (error.name === "TypeError" && /failed to fetch|networkerror when attempting|load failed/i.test(error.message)) return true
  const status = (error as Error & { statusCode?: unknown }).statusCode
  return status === 401 || status === 502 || status === 503 || status === 504
}
